import React, { useEffect, useState } from "react";
import "./Labs.css";
import Header from "Components/Header/Header";
import Footer from "Components/Footer/Footer";
import dot3 from "Assests/Images/dot3.svg";
import labs from "Assests/Images/labs.png";
import RightArrow from "Assests/Icons/RightArrow.svg";
import medicine from "Assests/Images/accompagnement-medecin-PhiRh 1.png";
import httpPathName from "Global/Config/Config";
import { useDispatch, useSelector } from "react-redux";
import { setAlert } from "../../Redux/Actions/alert.action";
import { useNavigate } from "react-router-dom";
// import useMetaTags from "Components/Hooks/useMetaTags";
import MetaDetails from "Components/MetaDetails/MetaDetails";
import Wanner from "Components/Wnner/Wanner";

const Labs = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("access_token");
  // const [location, setLocation] = useState("");
  // const [name, setName] = useState("");
  const [formValue, setFormValue] = useState({
    location: "",
    name: "",
  });

  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    findLabs();
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const findLabs = async () => {
    // if (!location || !name) {
    //   dispatch(setAlert("error", "Please Select Loaction or Name"));
    //   return;
    // }
    const apiStatus = await httpPathName
      .post("home/getAllLabs", formValue, {
        headers: { "x-auth-token": token },
      })
      .then((response) => {
        setData(response.data?.data);
        // dispatch(setAlert("success", response?.data?.message));
        setFormValue({});
      })
      .catch((err) => {
        console.log(err);
        dispatch(setAlert("error", err?.response?.data?.message));
      });
  };
  // console.log("data", data);

  // Using Custom Hook for adding Meta Title and Meta Description for Page
  // useMetaTags("Our State-of-the-Art Diagnostic Labs Ensure Accurate Results","Nederlands Diagnostics operates advanced diagnostic labs equipped with advanced technology and staffed by experienced professionals, ensuring accurate and reliable test results.")

  return (
    <>
      <MetaDetails
        title="Our State-of-the-Art Diagnostic Labs Ensure Accurate Results"
        description="Nederlands Diagnostics operates advanced diagnostic labs equipped with advanced technology and staffed by experienced professionals, ensuring accurate and reliable test results."
      />

      <Header />
      <div className="labs">
        <Wanner title="Find Our Labs" image={labs} dot={false} />
        <div className="section1">
          <div className="location-search">
            <div className="location">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M19.2805 6.34001C18.8169 5.4544 18.178 4.67236 17.4027 4.04144C16.6274 3.41052 15.7318 2.94392 14.7705 2.67001C13.8696 2.40898 12.9382 2.26777 12.0005 2.25001C11.1049 2.24898 10.2133 2.37009 9.35045 2.61001C8.37713 2.88075 7.46997 3.34897 6.68546 3.98553C5.90095 4.62208 5.25589 5.41333 4.79045 6.31001C4.27981 7.28068 3.97214 8.34515 3.88618 9.43857C3.80022 10.532 3.93777 11.6315 4.29045 12.67C5.33839 15.7469 7.12771 18.5184 9.50045 20.74C10.1751 21.3808 11.07 21.7381 12.0005 21.7381C12.9309 21.7381 13.8258 21.3808 14.5005 20.74C16.8871 18.5024 18.6837 15.7096 19.7305 12.61C20.0827 11.5887 20.2244 10.5066 20.1471 9.42896C20.0698 8.35135 19.7749 7.30057 19.2805 6.34001ZM18.2805 12.19C17.3092 15.0369 15.6542 17.6019 13.4605 19.66C13.0655 20.0401 12.5386 20.2524 11.9905 20.2524C11.4423 20.2524 10.9154 20.0401 10.5205 19.66C8.30966 17.5766 6.64717 14.9799 5.68045 12.1C5.40127 11.265 5.29628 10.3816 5.37196 9.50441C5.44764 8.62722 5.70238 7.77487 6.12045 7.00001C6.48612 6.2768 6.99733 5.63699 7.622 5.12073C8.24668 4.60448 8.97132 4.22292 9.75045 4.00001C10.486 3.81708 11.2427 3.733 12.0005 3.75001C12.8 3.76899 13.5935 3.89339 14.3605 4.12001C15.1325 4.32411 15.8543 4.6852 16.4805 5.18073C17.1068 5.67625 17.6242 6.29557 18.0005 7.00001C18.3976 7.80042 18.6281 8.67313 18.6779 9.56525C18.7278 10.4574 18.5959 11.3503 18.2905 12.19H18.2805Z"
                  fill="black"
                />
                <path
                  d="M12 6.25C11.2583 6.25 10.5333 6.46993 9.91661 6.88199C9.29993 7.29404 8.81928 7.87971 8.53545 8.56494C8.25163 9.25016 8.17736 10.0042 8.32206 10.7316C8.46675 11.459 8.8239 12.1272 9.34835 12.6517C9.8728 13.1761 10.541 13.5333 11.2684 13.6779C11.9958 13.8226 12.7498 13.7484 13.4351 13.4645C14.1203 13.1807 14.706 12.7001 15.118 12.0834C15.5301 11.4667 15.75 10.7417 15.75 10C15.75 9.00544 15.3549 8.05161 14.6517 7.34835C13.9484 6.64509 12.9946 6.25 12 6.25ZM12 12.25C11.555 12.25 11.12 12.118 10.75 11.8708C10.38 11.6236 10.0916 11.2722 9.92127 10.861C9.75098 10.4499 9.70642 9.9975 9.79323 9.56105C9.88005 9.12459 10.0943 8.72368 10.409 8.40901C10.7237 8.09434 11.1246 7.88005 11.561 7.79323C11.9975 7.70642 12.4499 7.75097 12.861 7.92127C13.2722 8.09157 13.6236 8.37996 13.8708 8.74997C14.118 9.11998 14.25 9.55499 14.25 10C14.25 10.5967 14.0129 11.169 13.591 11.591C13.169 12.0129 12.5967 12.25 12 12.25Z"
                  fill="black"
                />
              </svg>
              <span>
                <select
                  name="choose-location"
                  onChange={(e) =>
                    setFormValue({ ...formValue, location: e.target.value })
                  }
                  value={formValue?.location || ""}
                >
                  <option hidden value="">
                    Choose Location
                  </option>
                  <option value="Quezon">Quezon City</option>
                  <option value="Philippines">Philippines</option>
                </select>
              </span>
            </div>
            <div className="search">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M21.5305 20.47L16.8405 15.78C18.1991 14.1486 18.8765 12.0561 18.7318 9.938C18.587 7.81985 17.6313 5.83905 16.0633 4.40762C14.4953 2.97619 12.4359 2.20434 10.3134 2.25262C8.19082 2.30091 6.1686 3.16561 4.66735 4.66686C3.1661 6.16811 2.3014 8.19033 2.25311 10.3129C2.20483 12.4354 2.97668 14.4949 4.40811 16.0628C5.83954 17.6308 7.82034 18.5865 9.93849 18.7313C12.0566 18.876 14.1491 18.1986 15.7805 16.84L20.4705 21.53C20.6111 21.6704 20.8017 21.7493 21.0005 21.7493C21.1992 21.7493 21.3899 21.6704 21.5305 21.53C21.6709 21.3894 21.7498 21.1987 21.7498 21C21.7498 20.8012 21.6709 20.6106 21.5305 20.47ZM3.75048 10.5C3.75048 9.16497 4.14636 7.85993 4.88806 6.7499C5.62976 5.63986 6.68397 4.7747 7.91737 4.26381C9.15077 3.75292 10.508 3.61925 11.8173 3.8797C13.1267 4.14015 14.3295 4.78302 15.2735 5.72703C16.2175 6.67103 16.8603 7.87376 17.1208 9.18314C17.3812 10.4925 17.2476 11.8497 16.7367 13.0831C16.2258 14.3165 15.3606 15.3707 14.2506 16.1124C13.1406 16.8541 11.8355 17.25 10.5005 17.25C8.71109 17.2474 6.99573 16.5353 5.73044 15.27C4.46514 14.0047 3.75313 12.2894 3.75048 10.5Z"
                    fill="black"
                  />
                </svg>
                <input
                  type="text"
                  placeholder="Find Labs"
                  value={formValue?.name || ""}
                  onChange={(e) =>
                    setFormValue({ ...formValue, name: e.target.value })
                  }
                />
              </div>
              <button onClick={findLabs}>
                <img src={RightArrow} alt="RightArrow" />
              </button>
            </div>
          </div>
        </div>

        <div className="section3">
          <div className="cardWrapper">
            {data?.length > 0 &&
              data.map((item, i) => (
                <div key={i} className="card">
                  <img src={item?.image} alt={item?.lab_name} />
                  <div className="contentWrapper">
                    <h1>{item?.lab_name}</h1>
                    <p>{item?.description}</p>
                    <div className="oneline">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M19.2805 6.34001C18.8169 5.4544 18.178 4.67236 17.4027 4.04144C16.6274 3.41052 15.7318 2.94392 14.7705 2.67001C13.8696 2.40898 12.9382 2.26777 12.0005 2.25001C11.1049 2.24898 10.2133 2.37009 9.35045 2.61001C8.37713 2.88075 7.46997 3.34897 6.68546 3.98553C5.90095 4.62208 5.25589 5.41333 4.79045 6.31001C4.27981 7.28068 3.97214 8.34515 3.88618 9.43857C3.80022 10.532 3.93777 11.6315 4.29045 12.67C5.33839 15.7469 7.12771 18.5184 9.50045 20.74C10.1751 21.3808 11.07 21.7381 12.0005 21.7381C12.9309 21.7381 13.8258 21.3808 14.5005 20.74C16.8871 18.5024 18.6837 15.7096 19.7305 12.61C20.0827 11.5887 20.2244 10.5066 20.1471 9.42896C20.0698 8.35135 19.7749 7.30057 19.2805 6.34001ZM18.2805 12.19C17.3092 15.0369 15.6542 17.6019 13.4605 19.66C13.0655 20.0401 12.5386 20.2524 11.9905 20.2524C11.4423 20.2524 10.9154 20.0401 10.5205 19.66C8.30966 17.5766 6.64717 14.9799 5.68045 12.1C5.40127 11.265 5.29628 10.3816 5.37196 9.50441C5.44764 8.62722 5.70238 7.77487 6.12045 7.00001C6.48612 6.2768 6.99733 5.63699 7.622 5.12073C8.24668 4.60448 8.97132 4.22292 9.75045 4.00001C10.486 3.81708 11.2427 3.733 12.0005 3.75001C12.8 3.76899 13.5935 3.89339 14.3605 4.12001C15.1325 4.32411 15.8543 4.6852 16.4805 5.18073C17.1068 5.67625 17.6242 6.29557 18.0005 7.00001C18.3976 7.80042 18.6281 8.67313 18.6779 9.56525C18.7278 10.4574 18.5959 11.3503 18.2905 12.19H18.2805Z"
                          fill="black"
                        />
                        <path
                          d="M12 6.25C11.2583 6.25 10.5333 6.46993 9.91661 6.88199C9.29993 7.29404 8.81928 7.87971 8.53545 8.56494C8.25163 9.25016 8.17736 10.0042 8.32206 10.7316C8.46675 11.459 8.8239 12.1272 9.34835 12.6517C9.8728 13.1761 10.541 13.5333 11.2684 13.6779C11.9958 13.8226 12.7498 13.7484 13.4351 13.4645C14.1203 13.1807 14.706 12.7001 15.118 12.0834C15.5301 11.4667 15.75 10.7417 15.75 10C15.75 9.00544 15.3549 8.05161 14.6517 7.34835C13.9484 6.64509 12.9946 6.25 12 6.25ZM12 12.25C11.555 12.25 11.12 12.118 10.75 11.8708C10.38 11.6236 10.0916 11.2722 9.92127 10.861C9.75098 10.4499 9.70642 9.9975 9.79323 9.56105C9.88005 9.12459 10.0943 8.72368 10.409 8.40901C10.7237 8.09434 11.1246 7.88005 11.561 7.79323C11.9975 7.70642 12.4499 7.75097 12.861 7.92127C13.2722 8.09157 13.6236 8.37996 13.8708 8.74997C14.118 9.11998 14.25 9.55499 14.25 10C14.25 10.5967 14.0129 11.169 13.591 11.591C13.169 12.0129 12.5967 12.25 12 12.25Z"
                          fill="black"
                        />
                      </svg>
                      <p>{item.address}</p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <div className="oneline">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="34"
                          height="34"
                          viewBox="0 0 34 34"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_1910_3627)">
                            <path
                              d="M21.1044 25.4304L21.0753 23.3093C21.0333 22.5585 20.711 21.851 20.172 21.3266C19.6331 20.8023 18.917 20.4994 18.1654 20.478C17.8038 20.4757 17.457 20.3336 17.1979 20.0815C16.9387 19.8293 16.7871 19.4866 16.7749 19.1251L16.7168 14.8829C16.7128 14.7024 16.7447 14.5228 16.8108 14.3547C16.8769 14.1867 16.9758 14.0335 17.1017 13.904C17.2277 13.7746 17.3781 13.6715 17.5443 13.6009C17.7105 13.5302 17.8891 13.4934 18.0697 13.4925C18.4467 13.4874 18.819 13.4081 19.1654 13.2591C19.5117 13.1101 19.8253 12.8944 20.0882 12.6241C20.3512 12.3539 20.5583 12.0345 20.6977 11.6842C20.8372 11.3339 20.9062 10.9595 20.901 10.5825L20.8719 8.46142C20.8652 8.07879 20.7809 7.7015 20.6242 7.35237C20.4674 7.00324 20.2415 6.68952 19.9601 6.43018C19.3472 5.89966 18.5529 5.62674 17.7433 5.66852L16.9012 5.63055C15.501 5.64211 14.1537 6.16784 13.1157 7.10778C12.0777 8.04772 11.4213 9.33632 11.2713 10.7286C11.0533 12.8346 10.9595 14.9517 10.9904 17.0687C11.0198 19.1524 11.1663 21.2328 11.4293 23.3C11.5962 24.5969 12.1957 25.7996 13.1309 26.7135C13.6684 27.2451 14.3058 27.665 15.0064 27.9491C15.7069 28.2333 16.4568 28.3759 17.2127 28.369L18.2592 28.3546C18.6386 28.3514 19.0136 28.273 19.3625 28.1239C19.7114 27.9749 20.0273 27.7581 20.2919 27.4861C20.5565 27.2142 20.7645 26.8925 20.904 26.5396C21.0434 26.1868 21.1115 25.8098 21.1044 25.4304ZM18.2526 26.8414L17.2061 26.8557C16.16 26.8624 15.1477 26.4857 14.3604 25.7968C13.573 25.1079 13.0653 24.1545 12.9331 23.1167C12.6651 21.1185 12.5124 19.1066 12.4758 17.0908C12.4446 15.0306 12.5345 12.9703 12.7448 10.9206C12.8572 9.88968 13.3451 8.93625 14.1156 8.24221C14.8861 7.54818 15.8852 7.16213 16.9222 7.15776L17.7848 7.14594C18.2036 7.1277 18.6133 7.27152 18.9288 7.5475C19.0535 7.66668 19.1532 7.80949 19.2221 7.96759C19.2911 8.12569 19.3279 8.29593 19.3304 8.4684L19.3594 10.5895C19.3622 10.9527 19.2218 11.3023 18.9685 11.5626C18.7153 11.8229 18.3696 11.9728 18.0066 11.98C17.6296 11.985 17.2572 12.0643 16.9109 12.2133C16.5645 12.3623 16.2509 12.5781 15.988 12.8483C15.7251 13.1185 15.518 13.4379 15.3785 13.7882C15.2391 14.1385 15.17 14.5129 15.1753 14.8899L15.2334 19.1321C15.2385 19.5091 15.3177 19.8814 15.4667 20.2278C15.6157 20.5741 15.8315 20.8877 16.1017 21.1507C16.372 21.4136 16.6914 21.6207 17.0417 21.7601C17.392 21.8996 17.7663 21.9687 18.1433 21.9634C18.5049 21.9656 18.8517 22.1077 19.1109 22.3599C19.37 22.6121 19.5216 22.9548 19.5338 23.3162L19.5628 25.4374C19.5695 25.7957 19.4365 26.1426 19.192 26.4047C18.9474 26.6667 18.6105 26.8233 18.2526 26.8414ZM21.3976 15.3492C21.8253 15.7653 22.0702 16.3343 22.0784 16.931C22.0865 17.5277 21.8574 18.1031 21.4412 18.5308C21.3025 18.6734 21.2261 18.8652 21.2288 19.0641C21.2316 19.263 21.3132 19.4527 21.4557 19.5914C21.5983 19.7301 21.7901 19.8065 21.989 19.8038C22.1879 19.8011 22.3776 19.7194 22.5163 19.5769C23.2099 18.864 23.5919 17.9049 23.5782 16.9104C23.5646 15.916 23.1565 14.9676 22.4437 14.2741C22.3011 14.1354 22.1093 14.059 21.9104 14.0617C21.7115 14.0644 21.5218 14.146 21.3831 14.2886C21.2444 14.4312 21.168 14.623 21.1707 14.8219C21.1734 15.0208 21.2551 15.2104 21.3976 15.3492Z"
                              fill="black"
                            />
                            <path
                              d="M23.4896 13.1987C24.4851 14.171 25.0548 15.4982 25.0738 16.8896C25.0929 18.2811 24.5598 19.6234 23.5913 20.6226C23.4525 20.7652 23.3761 20.957 23.3789 21.1559C23.3816 21.3548 23.4632 21.5445 23.6058 21.6832C23.7484 21.8219 23.9402 21.8983 24.1391 21.8956C24.338 21.8928 24.5276 21.8112 24.6663 21.6686C25.9123 20.3843 26.5982 18.6583 26.5737 16.8691C26.5492 15.0799 25.8163 13.3733 24.5356 12.1236C24.393 11.9849 24.2012 11.9085 24.0023 11.9112C23.8034 11.9139 23.6137 11.9956 23.475 12.1381C23.3363 12.2807 23.2599 12.4725 23.2626 12.6714C23.2654 12.8703 23.347 13.06 23.4896 13.1987Z"
                              fill="black"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1910_3627">
                              <rect
                                width="24"
                                height="24"
                                fill="white"
                                transform="translate(16.7676 0.03125) rotate(44.2152)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        <p>{item?.contact_number}</p>
                      </div>
                      {item?.status === "open" ? (
                        <span
                          style={{
                            color: "#3AA1ED",
                            fontWeight: "500",
                            marginTop: "5px",
                          }}
                        >
                          Open
                        </span>
                      ) : (
                        <span
                          style={{
                            color: "#A71F23",
                            fontWeight: "500",
                            marginTop: "5px",
                          }}
                        >
                          Closed
                        </span>
                      )}
                    </div>
                    <div className="oneline">
                      <p>Reviews</p>
                      {new Array(item?.reviews).fill(0).map((d, i) => (
                        <svg
                          key={i}
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="17"
                          viewBox="0 0 18 17"
                          fill="none"
                        >
                          <path
                            d="M9 0L11.0206 6.21885H17.5595L12.2694 10.0623L14.2901 16.2812L9 12.4377L3.70993 16.2812L5.73056 10.0623L0.440492 6.21885H6.97937L9 0Z"
                            fill="#F99D1C"
                          />
                        </svg>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Labs;
